import { render } from "./Link.vue?vue&type=template&id=eaf436f8&scoped=true&lang=pug"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"

import "./Link.vue?vue&type=style&index=0&id=eaf436f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaf436f8"]])

export default __exports__